import type { LocaleBundle } from '../types.js'

export const ja: LocaleBundle = {
  code: 'ja',
  name: '日本語',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'ホーム',
    'common:search': '検索',
    'common:loading': '読み込み中…',
    'common:save': '保存',
    'common:cancel': 'キャンセル',
    'common:delete': '削除',
    'common:create': '作成',
    'common:edit': '編集',
    'common:show': '表示',
    'common:back': '戻る',
    'common:noRecords': 'レコードが見つかりません。',
    'common:noRecordsHint': '新しい{resource}を作成して始めましょう。',
    'common:noMatchingRecords': 'フィルターに一致するレコードがありません。',
    'common:clearFilters': 'フィルターをクリア',
    'common:confirmDelete': 'このレコードを削除しますか？',
    'common:confirmAction': '操作を確認しますか？',
    'common:confirm': '確認',
    'common:perPage': '1ページあたり',
    'common:page': 'ページ',
    'common:of': '/',
    'common:total': '合計',
    'auth:login': 'ログイン',
    'auth:logout': 'ログアウト',
    'auth:email': 'メールアドレス',
    'auth:password': 'パスワード',
    'auth:loginFailed': '認証情報が無効です。',
    'errors:notFound': '見つかりません。',
    'errors:forbidden': 'このリソースへのアクセス権がありません。',
    'errors:server': 'エラーが発生しました。再試行してください。',
    'common:resources': 'リソース',
    'common:actions': 'アクション',
    'action:notFound': 'アクション「{action}」はこのリソースでは利用できません。',
    'action:componentMissing': '「{component}」という名前のコンポーネントが登録されていません。',
    'action:componentMissingHint': '<ModernAdminProvider components={…}> に渡す ComponentLoader に登録してください。',
    'action:loadFailed': 'アクションの読み込みに失敗しました。',
    'common:new': '新規',
    'common:rowsPerPage': '1ページの行数',
    'common:filter': '{label}でフィルター…',
    'validation:required': '{label}は必須です',
    'validation:invalidNumber': '{label}は有効な数値である必要があります',
    'validation:invalidInteger': '{label}は整数である必要があります',
    'validation:invalidEmail': '{label}は有効なメールアドレスである必要があります',
    'validation:invalidUrl': '{label}は有効なURLである必要があります',
    'validation:invalidDate': '{label}は有効な日付である必要があります',
    'validation:invalidUuid': '{label}は有効なUUIDである必要があります',
    'validation:tooShort': '{label}は{min}文字以上で入力してください',
    'validation:tooLong': '{label}は{max}文字以内で入力してください',
    'validation:notInList': '{label}の値が無効です',
    'validation:emptySelection': '{label}を1つ以上選択してください',
    'toast:created': '作成しました',
    'toast:saved': '保存しました',
    'toast:deleted': '削除しました',
    'toast:createFailed': '作成に失敗しました',
    'toast:saveFailed': '保存に失敗しました',
    'toast:deleteFailed': '削除に失敗しました',
    'toast:loadFailed': '読み込みに失敗しました',
    'toast:validationFailed': 'エラーを修正してから再度お試しください',
    'common:close': '閉じる',
    'common:export': 'エクスポート',
    'export:title': 'レコードをエクスポート',
    'export:description': '{resource} の該当レコードをすべて 1 つのファイルにダウンロードします。',
    'export:csvHint': 'カンマ区切り値',
    'export:jsonHint': '構造化された JSON 配列',
    'export:downloading': 'ダウンロードを準備しています…',
    'export:progress': '{loaded} / {total} 件読み込み済み…',
    'export:exported': '{count} 件のレコードをエクスポートしました',
    'export:exportFailed': 'エクスポートに失敗しました',
    'common:apply': '適用',
    'common:clear': 'クリア',
    'common:filters': 'フィルター',
    'common:columns': '列',
    'common:toggleColumns': '列の表示切替',
    'common:openMenu': 'メニューを開く',
    'common:refresh': '更新',
    'common:copy': 'コピー',
    'common:copied': 'コピーしました！',
    'common:applyFilters': 'フィルターを適用',
    'common:clearAll': 'すべてクリア',
    'common:any': '任意',
    'common:yes': 'はい',
    'common:no': 'いいえ',
    'common:filterPlaceholder': '絞り込み…',
    'common:loadFailed': '読み込みに失敗しました: {error}',
    'common:theme': 'テーマ',
    'common:language': '言語',
    'common:toggleTheme': 'テーマ切替',
    'common:clearSelection': '選択を解除',
    'common:searchPlaceholder': '検索…',
    'home:searchResources': 'リソースを検索…',
    'home:noMatchingResources': '一致するリソースが見つかりません。',
    'globalSearch:title': 'グローバル検索',
    'globalSearch:description': 'すべてのリソースとレコードを検索します。',
    'globalSearch:trigger': '検索…',
    'globalSearch:placeholder': 'すべてのリソースを検索…',
    'globalSearch:hint': '入力してすべてのリソースを検索します。',
    'globalSearch:noResults': '一致するレコードが見つかりません。',
    'globalSearch:error': '検索に失敗しました。もう一度お試しください。',
    'globalSearch:hotkey': 'グローバル検索を開く',
    'globalSearch:matchedIn': '{field}内',
    'globalSearch:recent': '最近の検索',
    'globalSearch:clearRecent': 'クリア',
    'globalSearch:showAllIn': '{resource}内をすべて表示',
    'common:pageOf': '{total} ページ中 {page} ページ',
    'common:firstPage': '最初のページ',
    'common:previousPage': '前のページ',
    'common:nextPage': '次のページ',
    'common:lastPage': '最後のページ',
    'common:recordsCount': '{count} 件',
    'common:selectedCount': '{count} 件選択中',
    'common:selectRow': '行を選択',
    'common:selectAll': 'すべて選択',
    'common:deleteSelected': '選択を削除',
    'common:bulkDeleteConfirm': '選択した {count} 件のレコードを削除しますか？',
    'toast:bulkDeleted': '{count} 件を削除しました',
    'toast:bulkDeleteFailed': 'レコードの削除に失敗しました',
    'common:from': 'から',
    'common:to': 'まで',
    'common:sortBy': '並び順',
    'common:next': '次へ',
    'common:previous': '前へ',
    'common:relatedRecords': '関連レコード',
    'common:viewAll': 'すべて表示',
    'common:noRelatedRecords': '関連レコードはありません。',
    'common:preview': 'プレビュー',
    'common:download': 'ダウンロード',
    'common:openInNewTab': '新しいタブで開く',
    'common:format': '整形',
    'common:invalidJson': '無効な JSON です',
    'common:showPassword': 'パスワードを表示',
    'common:hidePassword': 'パスワードを非表示',
    'common:shortcutsHelp': 'キーボードショートカット',
    'common:shortcutsEmpty': 'この画面でのショートカットはありません。',
    'auth:title': 'サインイン',
    'auth:subtitle': 'メールアドレスとパスワードを入力してください',
    'auth:tagline': 'あらゆるスタックに対応したモダンな管理パネル。',
    'auth:orContinueWith': 'または連携してログイン',
    'auth:continueWith': '{provider}でログイン',
    'common:chooseFile': 'ファイルを選択',
    'common:chooseFiles': 'ファイルを選択',
    'common:dragAndDrop': 'ドラッグ＆ドロップまたは',
    'common:chooseAFile': 'ファイルを選択',
    'common:addMoreFiles': 'ファイルを追加',
    'common:uploading': 'アップロード中…',
    'common:uploadingFile': '{name} をアップロード中…',
    'common:removeFile': 'ファイルを削除',
    'common:uploadFailed': 'アップロード失敗',
    'common:dismiss': '閉じる',
    'common:openCalendar': 'カレンダーを開く',
    'common:time': '時刻',
    'common:downloadFailed': 'ダウンロード失敗',
    'richtext:bold': '太字',
    'richtext:italic': '斜体',
    'richtext:strikethrough': '取り消し線',
    'richtext:inlineCode': 'インラインコード',
    'richtext:heading': '見出し {level}',
    'richtext:bulletList': '箇条書き',
    'richtext:numberedList': '番号付きリスト',
    'richtext:blockquote': '引用',
    'richtext:horizontalRule': '水平線',
    'richtext:insertLink': 'リンクを挿入',
    'richtext:undo': '元に戻す',
    'richtext:redo': 'やり直し',
    'richtext:source': 'ソース ({format})',
    'richtext:splitView': '分割表示',
    'richtext:visualEditor': 'ビジュアルエディタ',
    'richtext:fullscreen': 'フルスクリーン',
    'richtext:exitFullscreen': 'フルスクリーンを終了',
    'richtext:urlPrompt': 'URL',
    'common:saving': '保存中…',
    'common:done': '完了',
    'settings:menuItem': '設定',
    'settings:noSectionsConfigured': 'このデプロイメントで利用できる設定セクションはありません。',
    'settings:apiKeys.title': 'APIキー',
    'settings:apiKeys.description': '管理APIへのプログラムアクセス用トークン。各キーには、呼び出せるリソースとアクションを制限する権限セットが含まれます。',
    'settings:apiKeys.actions.create': '新しいキー',
    'settings:apiKeys.actions.edit': '編集',
    'settings:apiKeys.actions.revoke': '無効化',
    'settings:apiKeys.empty.title': 'APIキーがまだありません',
    'settings:apiKeys.empty.description': '最初のキーを作成してプログラムアクセスを許可しましょう。',
    'settings:apiKeys.columns.name': '名前',
    'settings:apiKeys.columns.start': 'プレフィックス',
    'settings:apiKeys.columns.permissions': '権限',
    'settings:apiKeys.columns.expiresAt': '有効期限',
    'settings:apiKeys.columns.enabled': '有効',
    'settings:apiKeys.columns.actions': '操作',
    'settings:apiKeys.lastUsed': '最終使用 {date}',
    'settings:apiKeys.expiresNever': '無期限',
    'settings:apiKeys.permissions.resource': 'リソース',
    'settings:apiKeys.permissions.actions': 'アクション',
    'settings:apiKeys.permissions.selectAll': 'すべて選択',
    'settings:apiKeys.permissions.clearAll': 'すべて解除',
    'settings:apiKeys.permissions.none': '権限なし',
    'settings:apiKeys.permissions.summary': '{resources}件のリソース · {actions}件のアクション',
    'settings:apiKeys.permissions.noResources': '登録されているリソースがありません。',
    'settings:apiKeys.permissions.selectAllResources': 'すべてのリソースとアクションを選択',
    'settings:apiKeys.permissions.clearAllResources': 'すべてのリソースとアクションを解除',
    'settings:apiKeys.editor.titleCreate': '新しいAPIキー',
    'settings:apiKeys.editor.titleEdit': 'APIキーを編集',
    'settings:apiKeys.editor.description': '分かりやすい名前を付け、このキーが本当に必要とするリソースとアクションだけを許可してください。',
    'settings:apiKeys.editor.name': '名前',
    'settings:apiKeys.editor.namePlaceholder': '例: CIデプロイボット',
    'settings:apiKeys.editor.expiresInDays': '有効期限（日数）',
    'settings:apiKeys.editor.expiresPlaceholder': '無期限',
    'settings:apiKeys.editor.expiresHint': '無期限にする場合は空欄のままにします。最大3650日。',
    'settings:apiKeys.editor.permissions': '権限',
    'settings:apiKeys.editor.selectedActions': '{count}件選択',
    'settings:apiKeys.created.title': 'APIキーを作成しました',
    'settings:apiKeys.created.description': '今すぐキーをコピーしてください — 再表示されません。',
    'settings:apiKeys.created.warning': '完全なキーが表示されるのは今回だけです。安全な場所に保管してください。',
    'settings:apiKeys.created.reveal': 'キーを表示',
    'settings:apiKeys.created.hide': 'キーを隠す',
    'settings:apiKeys.created.copy': 'コピー',
    'settings:apiKeys.created.copied': 'コピー済み',
    'settings:apiKeys.notice.revoked': 'APIキーを無効化しました',
    'settings:apiKeys.notice.updated': 'APIキーを更新しました',
    'settings:apiKeys.notice.copied': 'クリップボードにコピーしました',
    'settings:apiKeys.notice.copyFailed': 'クリップボードへのコピーに失敗しました',
    'settings:apiKeys.confirmRevoke.title': 'APIキーを無効化',
    'settings:apiKeys.confirmRevoke.description': '「{name}」を無効化しますか？このキーを使用しているすべてのサービスは即座に動作しなくなります。',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'ダッシュボード',
    'chart:addChart': 'グラフを追加',
    'chart:newChart': '新しいグラフ',
    'chart:editChart': 'グラフを編集',
    'chart:deleteChart': 'グラフを削除',
    'chart:noCharts': 'グラフがありません',
    'chart:noChartsHint': 'グラフを追加してデータの監視を始めましょう。',
    'chart:addGroup': 'グループを追加',
    'chart:newGroup': '新規グループ',
    'chart:editGroup': 'グループを編集',
    'chart:deleteGroup': 'グループを削除',
    'chart:saveGroup': 'グループを保存',
    'chart:groupName': 'グループ名',
    'chart:groupNamePlaceholder': '例: 売上指標',
    'chart:groupNameRequired': 'グループ名は必須です',
    'chart:groupOrder': 'グループの順序',
    'chart:order': '順序',
    'chart:orderHint': '値が小さいほど先に表示されます。',
    'chart:moveToGroup': 'グループに移動',
    'chart:moveChart': 'グラフを移動',
    'chart:moveGroup': 'グループ',
    'chart:moveNoGroups': 'まだグループがありません。',
    'chart:moveNoGroupsHint': 'グラフを整理するには、まずグループを作成してください。',
    'chart:deleteChartConfirm': 'このグラフを削除しますか?',
    'chart:deleteChartConfirmHint': 'この操作は取り消せません。',
    'chart:deleteGroupConfirm': 'このグループを削除しますか?',
    'chart:deleteGroupConfirmHint': 'グループと内部の {count} 件のグラフが完全に削除されます。',
    'chart:title': 'タイトル',
    'chart:titlePlaceholder': '例：1日あたりの新規ユーザー数',
    'chart:untitled': 'タイトルなし',
    'chart:chartType': 'グラフの種類',
    'chart:resource': 'リソース',
    'chart:groupBy': 'グループ化',
    'chart:step': 'ステップ',
    'chart:metric': '指標',
    'chart:aggregateField': '集計フィールド',
    'chart:selectField': 'フィールドを選択…',
    'chart:saveChart': 'グラフを保存',
    'chart:typeLine': '折れ線',
    'chart:typeArea': 'エリア',
    'chart:typeBar': '棒',
    'chart:typePie': '円',
    'chart:stepDay': '日',
    'chart:stepWeek': '週',
    'chart:stepMonth': '月',
    'chart:stepYear': '年',
    'chart:metricCount': '件数',
    'chart:metricSum': '合計',
    'chart:metricAvg': '平均',
    'chart:noData': '選択期間のデータがありません',
    'chart:loadError': 'グラフデータの読み込みに失敗しました',
    'chart:value': '値',
    'dashboard:vis': '表示形式',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': '折れ線',
    'dashboard:visArea': 'エリア',
    'dashboard:visBar': '棒',
    'dashboard:visPie': '円',
    'dashboard:metricCount': '件数',
    'dashboard:metricSum': '合計',
    'dashboard:metricAvg': '平均',
    'dashboard:metricMin': '最小',
    'dashboard:metricMax': '最大',
    'dashboard:builder.range': '期間',
    'dashboard:builder.filters': 'フィルター',
    'dashboard:builder.filtersHint': '集計前にデータを絞り込みます。チェックを付けると、グラフの上にクイックフィルターとして表示されます。',
    'dashboard:builder.quickFilterHint': 'このフィルターをダッシュボードのグラフ上部に表示します。',
    'dashboard:builder.quickFilterToggle': '{field} をクイックフィルターとして表示',
    'dashboard:range.7d': '7日',
    'dashboard:range.30d': '30日',
    'dashboard:range.90d': '90日',
    'dashboard:range.1y': '1年',
    'dashboard:range.all': '全期間',
    'dashboard:range.custom': 'カスタム',
    'dashboard:widget.previousPeriod': '前期比',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': '半分の幅に縮小',
    'dashboard:widget.expand': '全幅に拡大',
    'dashboard:widget.toggleSql': 'SQLを表示',
    'dashboard:widget.unsupported': 'お使いのデータベースではグラフをまだサポートしていません。',
    'dashboard:widget.truncatedWarning': '部分的なデータを表示しています。行数が多すぎて全期間を集計できません。',
    'dashboard:widget.showAll': 'すべて表示',
    'dashboard:widget.hideAll': 'すべて非表示',
    'dashboard:seriesTotal': '合計',
    'dashboard:seriesOther': 'その他',
    'dashboard:seriesNull': '空',
    'dashboard:builder.dateField': '日付フィールド',
    'dashboard:builder.dateFieldHint': 'X軸はこの日付列でバケット化されます。',
    'dashboard:builder.secondaryGroupBy': '内訳',
    'dashboard:builder.noBreakdown': '単一系列',
    'dashboard:builder.topN': '最大系列数',
    'dashboard:builder.width': '幅',
    'dashboard:width.half': '半分',
    'dashboard:width.full': '全幅',
    'dashboard:builder.comparePrevious': '前の期間と比較',
    'dashboard:builder.comparePreviousHint': '同じ長さの直前の期間を破線で重ねて表示し、タイトルの横に変化を表示します。',
    'dashboard:builder.comparePreviousDisabled': '内訳を使用している場合は利用できません。',
    'dashboard:builder.transform': '値の変換',
    'dashboard:builder.transformHint': '表示前に値へ適用されます — 例：100で割ってセントをドルとして表示。',
    'dashboard:builder.transformAdd': 'ステップを追加',
    'dashboard:builder.transformRemove': 'ステップを削除',
    'dashboard:builder.opDivide': '割る',
    'dashboard:builder.opMultiply': '掛ける',
    'dashboard:builder.opAdd': '足す',
    'dashboard:builder.opSubtract': '引く',
    'dashboard:builder.format': '値の形式',
    'dashboard:builder.formatStyle': 'スタイル',
    'dashboard:builder.formatNumber': '数値',
    'dashboard:builder.formatCurrency': '通貨',
    'dashboard:builder.formatPercent': 'パーセント',
    'dashboard:builder.formatCurrencyCode': '通貨コード',
    'dashboard:builder.formatDecimals': '小数点以下の桁数',
    'dashboard:builder.formatCompact': 'コンパクト表記（1.2万）',
    'dashboard:builder.formatPrefix': '接頭辞',
    'dashboard:builder.formatSuffix': '接尾辞',
    'dashboard:builder.color': '系列の色',
    'dashboard:widget.previousSeries': '{label}（前の期間）',
    'dashboard:widget.editColors': '色を編集',
    'dashboard:widget.colorsTitle': '系列の色',
    'dashboard:widget.colorCustom': 'カスタム',
    'dashboard:widget.colorAuto': '自動',
    'dashboard:widget.colorPick': '色を選択',
    'dashboard:builder.tabData': 'データ',
    'dashboard:builder.tabDisplay': '表示',
    'dashboard:builder.tabFilters': 'フィルター',
    'dashboard:builder.filtersEmpty': 'このリソースにはフィルター可能なフィールドがありません。',
    'history:revisions': 'リビジョン',
    'history:noRevisions': 'リビジョンはまだありません',
    'history:loadError': '変更履歴を読み込めませんでした',
    'history:revert': '元に戻す',
    'history:confirmRevert': 'このリビジョンに戻しますか？',
    'history:revertSuccess': 'リビジョンを復元しました',
    'history:revertFailed': 'リビジョンを復元できませんでした',
    'history:unknownUser': '不明なユーザー',
    'history:changes': '件の変更',
    'history:compareTo': '比較先',
    'history:storedDiff': '変更差分',
    'history:op.create': '作成',
    'history:op.update': '更新',
    'history:op.delete': '削除',
    'diff:added': '追加',
    'diff:changed': '変更',
    'diff:removed': '削除',
    'diff:before': '変更前',
    'diff:after': '変更後',
    'diff:noChanges': 'フィールド変更は記録されていません',
    'audit:title': 'アクティビティ',
    'audit:resource': 'リソース',
    'audit:action': 'アクション',
    'audit:recordId': 'レコードID',
    'audit:userId': 'ユーザーID',
    'audit:allResources': 'すべてのリソース',
    'audit:allActions': 'すべてのアクション',
    'audit:noEvents': 'アクティビティはまだありません',
    'audit:records': 'レコード',
    'audit:loadError': 'アクティビティを読み込めませんでした',
    'audit:by': '実行者: {user}',
    'audit:viewRecord': 'レコードを表示',
    'audit:viewChanges': '変更を表示',
    'audit:hideChanges': '変更を非表示',
    'audit:noDiff': '変更の詳細は利用できません',
    'audit:loadDiffError': '変更を読み込めませんでした',
    'audit:action.new': 'レコードを作成しました',
    'audit:action.edit': 'レコードを更新しました',
    'audit:action.delete': 'レコードを削除しました',
    'audit:action.bulkDelete': 'レコードを一括削除しました',
    'audit:action.login': 'サインイン',
    'audit:action.apiKeyCreate': 'APIキーを作成しました',
    'audit:action.apiKeyUpdate': 'APIキーを更新しました',
    'audit:action.apiKeyDelete': 'APIキーを削除しました',
    'audit:virtualResource.auth': '認証',
    'audit:virtualResource.apiKeys': 'APIキー',
    'audit:prevPage': '前へ',
    'audit:nextPage': '次へ',
    'audit:dateRangePlaceholder': '日付範囲を選択',
    'keyValue:noMatches': '一致なし — Enter キーで「{value}」をそのまま使用します。',
    'aiAssistant:queue.cancel': 'キューから削除',
    'aiAssistant:title': 'AI アシスタント',
    'aiAssistant:fab.label': 'AI アシスタントを開く',
    'aiAssistant:fab.short': 'AI',
    'aiAssistant:description': 'レコード、関連性、レポート、データ傾向について質問できます。',
    'aiAssistant:notConfigured.title': 'アシスタントが構成されていません',
    'aiAssistant:notConfigured.description': '読み取り専用 AI アシスタントを有効にするには、設定で OpenRouter API キーを追加してください。',
    'aiAssistant:notConfigured.openSettings': '設定を開く',
    'aiAssistant:tryAsking': '質問例:',
    'aiAssistant:tryAsking.example1': '投稿数が最も多い顧客は誰ですか？',
    'aiAssistant:tryAsking.example2': 'リソースの最近作成されたレコードを表示してください。',
    'aiAssistant:tryAsking.example3': '特定のレコード間の関連性を説明してください。',
    'aiAssistant:thinking': '考え中',
    'aiAssistant:thinkingProgress': '考え中 ({progress}%)',
    'aiAssistant:input.placeholder': 'データについて質問してください…',
    'aiAssistant:input.hint': 'Enterで送信 · Shift+Enterで改行',
    'aiAssistant:send': 'メッセージを送信',
    'aiAssistant:newChat': '新しいチャット',
    'aiAssistant:history': 'チャット履歴',
    'aiAssistant:history.empty': '以前のチャットはありません',
    'aiAssistant:noText': '関連するレコードが見つかりました:',
    'aiAssistant:fallback.noToolResult': 'リクエストは実行されましたが、モデルがテキスト回答を返しませんでした。質問を具体化するか、デバッグログを有効にしてツール結果を確認してください。',
    'aiAssistant:fallback.noRows': 'このリクエストに一致するレコードは見つかりませんでした。',
    'aiAssistant:fallback.rowsFound': '見つかった行数: {count}。',
    'aiAssistant:taskFailed': 'AI アシスタントのタスクが失敗しました',
    'aiAssistant:settings.title': 'AI アシスタント',
    'aiAssistant:settings.description': 'フローティング AI チャットウィジェット、モデル、サーバー側アシスタントの動作を構成します。',
    'aiAssistant:settings.enabled': '有効',
    'aiAssistant:settings.disabled': '無効',
    'aiAssistant:settings.configured': '構成済み',
    'aiAssistant:settings.apiKeyRequired': 'API キーが必要です',
    'aiAssistant:settings.readOnly': '読み取り専用',
    'aiAssistant:settings.provider': 'プロバイダー: {provider}',
    'aiAssistant:settings.enableLabel': 'アシスタントを有効化',
    'aiAssistant:settings.enableHint': 'フローティングウィジェットとチャットエンドポイントの表示を制御します。',
    'aiAssistant:settings.modelLabel': 'OpenRouter モデル',
    'aiAssistant:settings.apiKeyLabel': 'OpenRouter API キー',
    'aiAssistant:settings.apiKeyHint': 'サーバーに保存済みの既存キーを保持するには空のままにしてください。',
    'aiAssistant:settings.systemPromptLabel': 'システムプロンプトの上書き',
    'aiAssistant:settings.systemPromptPlaceholder': 'アシスタント向けのプロジェクト固有の指示（任意）',
    'aiAssistant:settings.accessTitle': 'アクセスモデル',
    'aiAssistant:settings.accessDescription': '現在のアシスタントは、管理リソースアクションを通じたレコードの読み取り専用検査に制限されています。',
    'aiAssistant:settings.futureToolsReady': '将来のツール対応',
    'aiAssistant:settings.save': '設定を保存',
    'aiAssistant:settings.saving': '保存中…',
    'aiAssistant:settings.saved': 'AI アシスタント設定を保存しました',
    'aiAssistant:settings.empty': '利用可能な設定はありません。',
    'aiFill:button': 'AI で入力',
    'aiFill:dialogTitle': '写真からフォームを入力',
    'aiFill:dialogDescription': '画像をアップロードしてください — AI が値を抽出してフォームに入力します。',
    'aiFill:fillButton': '認識する',
    'aiFill:processing': '画像を認識中\u2026',
    'aiFill:success': '{count} 個のフィールドが入力されました',
    'aiFill:errorNoFields': 'このリソースには AI で入力可能なフィールドがありません。',
    'aiFill:errorGeneric': 'AI による入力に失敗しました: {message}',
    'aiFill:noValues': 'AI はこの画像から値を抽出できませんでした。',
    'aiFill:applied': 'AI が {count} 件のフィールドを入力しました。以下で取り消せます。',
    'filter:op.co': '含む',
    'filter:op.nco': '含まない',
    'filter:op.sw': 'で始まる',
    'filter:op.ew': 'で終わる',
    'filter:op.eq': '等しい',
    'filter:op.neq': '等しくない',
    'filter:op.empty': '空',
    'filter:op.nempty': '空でない',
    'filter:op.in': 'いずれか',
    'filter:op.gt': 'より大きい',
    'filter:op.lt': 'より小さい',
    'filter:op.between': '範囲内',
    'filter:searchValues': 'リスト内を検索…',
    'filter:selectAll': 'すべて選択',
    'filter:noValues': '値が見つかりません',
    'common:newRecord': '新規 {name}',
    'common:editRecord': '{name} #{id} を編集',
    'common:themeLight': 'ライト',
    'common:themeDark': 'ダーク',
    'common:themeSystem': 'システム',
    'common:ok': 'OK',
    'common:select': '選択…',
    'common:removeItem': '{title} を削除',
    'common:nSelectedAddMore': '{count} 件選択中 — さらに追加',
    'common:pickRecords': 'レコードを選択',
    'common:managePickRecords': '選択を管理 ({count})',
    'common:pickRecordsFrom': '{name} から選択',
    'common:draftRestored': '未保存の下書きを復元しました',
    'common:undoDraftRestore': '元に戻す',
    'wizard:stepOf': 'ステップ {current} / {total}',
    'wizard:products.step1': '基本情報',
    'wizard:products.step2': '価格設定',
    'wizard:products.step3': 'メディア & タグ',
    'common:invalidValue': '無効な値です',
    'common:collapseSidebar': 'サイドバーを折りたたむ',
    'common:expandSidebar': 'サイドバーを展開する',
    'common:toggleSidebar': 'サイドバーの切り替え',
    'common:sidebarTitle': 'サイドバー',
    'common:sidebarNavigation': 'ナビゲーションメニュー',
    'cache:title': 'キャッシュ',
    'cache:description': 'このレプリカのキャッシュ状態とリソース別パフォーマンスです。',
    'cache:load.error': 'キャッシュメトリクスを読み込めませんでした',
    'cache:load.retry': '再試行',
    'cache:reset.action': 'メトリクスをリセット',
    'cache:reset.loading': 'キャッシュメトリクスをリセット中…',
    'cache:reset.success': 'キャッシュメトリクスをリセットしました',
    'cache:reset.error': 'キャッシュメトリクスをリセットできませんでした',
    'cache:metric.hitRate': 'ヒット率',
    'cache:metric.requests': 'キャッシュ読み取り',
    'cache:metric.avgCompute': '平均計算時間',
    'cache:metric.errors': 'エラー',
    'cache:unit.ms': '{value} ミリ秒',
    'cache:quarantine.title': '隔離中のタグ',
    'cache:quarantine.description': '無効化が成功するまで、これらのタグはキャッシュを迂回します。',
    'cache:invalidate.title': 'リソースキャッシュを無効化',
    'cache:invalidate.description': '設定済みレプリカからリソースの一覧とレコードを削除します。',
    'cache:invalidate.resource': 'リソース',
    'cache:invalidate.action': 'キャッシュを無効化',
    'cache:invalidate.loading': 'キャッシュを無効化中…',
    'cache:invalidate.success': 'リソースキャッシュを無効化しました',
    'cache:invalidate.error': 'リソースキャッシュを無効化できませんでした',
    'cache:table.title': '名前空間別メトリクス',
    'cache:table.empty': 'キャッシュアクティビティはまだ記録されていません。',
    'cache:instance': 'レプリカ {id}',
    'cache:table.namespace': '名前空間',
    'cache:table.resource': 'リソース',
    'cache:table.hits': 'ヒット',
    'cache:table.misses': 'ミス',
    'cache:table.computes': '計算',
    'cache:table.coalesced': '統合',
    'cache:table.errors': 'エラー',
  },
}
